// @flow

import React from 'react';

import {
  scoreCls,
  scoreResultCls,
  scoreResultItemCls,
  scoreResultPercentageCls,
  scoreResultNameCls,
  scoreAveragesCls,
} from 'shared_components/quiz/common/score/Score.less';

type Props = {
  values: Array<Object>,
  averages?: Array<Object>,
  averageScoreText?: any,
};

export const Score = ({ values = [], averages = [], averageScoreText = '' }: Props) => (
  <div className={scoreCls}>
    <ul className={scoreResultCls}>
      {values.map((i) => (
        <li key={i.resultCode} className={scoreResultItemCls}>
          <span className={scoreResultPercentageCls}>{`${Math.round(i.score * 100)}%`}</span>
          <span className={scoreResultNameCls}>{i.resultName}</span>
        </li>
      ))}
    </ul>
    {averages.length ? (
      <div className={scoreAveragesCls}>
        [ {averageScoreText}{' '}
        {averages.map((i) => `${Math.round(i.score * 100)}% ${i.resultName}`).join(', ')} ]
      </div>
    ) : null}
  </div>
);
